import { Component, inject } from '@angular/core';
import { SideNavService } from '../../layout/side-menu/side-nav.service';
import { ThemeService } from '../../../services/theme.service';
import { BurgerService } from '../../../services/burger.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-burger-menu',
    templateUrl: './burger-menu.component.html',
    styleUrls: ['./burger-menu.component.scss'],
    imports: [NgClass]
})
export class BurgerMenuComponent {
  sidenav = inject(SideNavService);
  theme = inject(ThemeService);
  burger = inject(BurgerService);


  toggle() {
    this.sidenav.toggle();
  }

}
